<template>
    <div>
        <component :is="currentComponent" @goToComponent="handleComponentChange" :money="componentParams.money">
        </component>
    </div>
</template>
<script>
import MyWallet from './Wallet/MyWallet.vue'
import Withdraw from './Wallet/Withdraw.vue'

export default {
    name: 'MyOrders',
    components: {
        MyWallet,
        Withdraw
    },
    data() {
        return {
            currentComponent: 'MyWallet',
            componentParams: {
                Money: '',
            }
        }
    },
    mounted() {
        // 组件挂载时默认显示订单列表
        this.currentComponent = 'MyWallet';
    },
    methods: {
        // 处理组件切换
        handleComponentChange(componentName, params) {
            if (params) {
                this.componentParams = { ...this.componentParams, ...params };
            }
            this.currentComponent = componentName;
        }
    }
}
</script>
<style scoped>
/* 可以根据需要添加样式 */
</style>